import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(form.email, form.password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back to the hunt.");
      navigate("/browse");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen text-white font-body flex flex-col">
      <div className="p-4 md:p-8">
        <Link to="/" data-testid="login-back-home" className="flex items-center">
          <Logo variant="nav" alt="Hunt57" />
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-4 pb-16">
        <div className="w-full max-w-md">
          <div className="font-mono text-xs text-[#FF5F1F] tracking-widest uppercase">→ Sign In</div>
          <h1 className="mt-3 font-display font-black uppercase text-4xl tracking-tighter">Welcome Back</h1>
          <p className="mt-3 text-zinc-400">Sign in to browse, list, and message.</p>

          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <label className="h57-label">Email</label>
              <input type="email" required autoFocus data-testid="login-email" className="h57-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </div>
            <div>
              <div className="flex items-center justify-between">
                <label className="h57-label">Password</label>
                <Link to="/forgot-password" data-testid="login-forgot-link" className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 hover:text-[#FFD700]">
                  Forgot?
                </Link>
              </div>
              <input type="password" required data-testid="login-password" className="h57-input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            </div>
            <button type="submit" disabled={loading} className="h57-btn-primary w-full" data-testid="login-submit">
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>

          <div className="mt-8 pt-6 border-t border-white/5 space-y-3 text-center">
            <p className="text-zinc-500 text-sm">
              No account? <Link to="/register" className="text-[#FF5F1F] hover:underline font-bold" data-testid="login-link-register">Sign up free →</Link>
            </p>
            <p className="text-zinc-600 text-xs">
              Want to sell cards? Upgrade to a vendor account after signing in.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
